<div class="flex flex-col gap-4">
	<p-select
		[options]="(companies$ | async) ?? []"
		[ngModel]="(activeCompany$ | async)"
		(ngModelChange)="switchToCompany($event)"
		optionLabel="name"
		appendTo="body"
		placeholder="Organisation auswählen"
		class="w-full">
	</p-select>
</div>
